import Image from 'next/image';
import React from 'react';
import fa from 'locales/fa.json';
import { CafebazaarRoute, DownloadUrl, TestFlightRoute } from 'services/routes';
import Link from 'next/link';

const Download: React.FC = () => {
  return (
    <div className="flex flex-col md:flex-row center overflow-hidden">
      <div className="w-[300px] bg-white z-10 p-[12px]  md:z-0  md:self-start center md:items-start flex-col mt-[60px] md:mt-32">
        <div className="text-blue-13 font-bold text-[24px]">
          {fa.download.downloadApp}
        </div>

        <a
          href={DownloadUrl()}
          target="_blank"
          download
          rel=" noreferrer"
          className="py-[8px] text-black w-[160px] cursor-pointer rounded-md text-[14px] mt-[40px] bg-gray-0 center"
        >
          <span className="ml-[6px]">{fa.download.directDownload}</span>
          <Image src="/direct-download.svg" width={24} height={24} alt="" />
        </a>
        <a
          href={CafebazaarRoute()}
          target="_blank"
          download
          rel=" noreferrer"
          className="py-[8px] text-black w-[160px] cursor-pointer rounded-md text-[14px] mt-[20px] bg-gray-0 center"
        >
          <span className="ml-[6px]">{fa.download.cafebazarDownload}</span>
          <Image src="/bazaar-icon.webp" width={24} height={24} alt="" />
        </a>
        <Link href={TestFlightRoute()}>
          <a className="py-[8px] text-black w-[160px] flex items-center cursor-pointer rounded-md text-[14px] mt-[20px] bg-gray-0 center">
            <span className="ml-[6px] mt-[2px]">دانلود نسخه ios</span>
            <Image src="/apple.gif" width={20} height={20} alt="" />
          </a>
        </Link>

        {/* <a
          href={GooglePlayRoute()}
          target="_blank"
          rel=" noreferrer"
          className="py-[8px] w-[160px] text-black rounded-md cursor-pointer text-[14px] mt-[12px] bg-gray-0 center"
        >
          <span className="ml-[6px]">{fa.download.googleDownload}</span>
          <Image src="/google-play.svg" width={28} height={28} alt="" />
        </a> */}
      </div>
      <div className="w-[400px] md:w-[600px] h-[360px] md:h-[540px] rotate-45">
        <Image src="/download.png" width={640} height={665} alt="" />
      </div>
    </div>
  );
};

export default Download;
